




























































































































import { ScheduleSlotRangeItemForAccessControl } from '@bookings/interfaces/schedule';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { VueSelecto } from 'vue-selecto';
@Component({
  name: 'schedule-slot-range-selector',
  components: {
    'vue-selecto': VueSelecto,
  },
})
export default class ScheduleSelectorForAccessControl extends Vue {
  @Prop({
    type: Array,
    default() {
      return null;
    },
  })
  readonly value: ScheduleSlotRangeItemForAccessControl[];

  get model(): ScheduleSlotRangeItemForAccessControl[] {
    return this.value;
  }

  set model(value) {
    this.$emit('input', value);
  }

  openSelected: boolean = false;

  getCellStyle(open: boolean) {
    if (open) {
      return {
        'background-color': '#FFF9C4',
      };
    }

    return {
      'background-color': 'rgba(0, 0, 0, 0.1)',
    };
  }

  get openBtnStyle() {
    const color = '#FFF9C4';
    const opacity = this.openSelected ? 1 : 0.6;
    return {
      'border-width': '0px',
      'background-color': color + ' !important',
      opacity: opacity,
    };
  }

  onSelect(e) {
    const addedRemoved = e.added.concat(e.removed);
    addedRemoved.forEach(el => {
      const day = el.getAttribute('data-day');
      const time = el.getAttribute('data-time');
      this.changeModel(day, time, this.openSelected);
    });
  }

  changeToOpen() {
    this.openSelected = true;
  }

  changeToClosed() {
    this.openSelected = false;
  }

  changeModel(day, time, open: boolean) {
    this.model = this.model.map(scheduleSlotRange => {
      if (scheduleSlotRange.start_time === time) {
        scheduleSlotRange[day] = open;
      }
      return scheduleSlotRange;
    });
  }
}
